import clienteAxios from "../services/axios"
import { authHeader } from "../helpers/auth-header"

export const getAnalyticsService = (id) => {
	return clienteAxios.get(`/info/analytics`, { headers: authHeader() })
}
